import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../ItemLedgerSlice";
import { fetchItemLedger } from "../ItemLedgerThunk";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";
import { fetchItems } from "../../../store/commonThunks/lookups";
import RecordDateFilter from "../../../components/filters/RecordDateFilter";
import { useDefaultDateRange } from "../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../components/common/filters/CommonDateRangeFilter";

const ItemLedgerFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.itemLedger);
  const lookups = useSelector((state) => state.lookups);

  // ✅ Automatically set today's date on page load
  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    dispatch(fetchItems());
  }, [dispatch]);

  useEffect(() => {
  if (filters.itemId && filters.fromDate && filters.toDate) {
    dispatch(fetchItemLedger({ filters }));
  }
  }, [filters]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.itemId) {
      messageApi.warning("Select Item");
      return;
    }

    dispatch(fetchItemLedger({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} wrap style={{ alignItems: "center" }}>
        <Col xs={24} sm={12} md={8} xl={5} xxl={4} >
          <label>Search Item</label>
          <SearchListAutoComplete
            optionsList={lookups.items.map((i) => ({
              sale_id: i.item_id,
              display_text: `${i.item_name} - ${i.item_code}`,
            }))}
            onSelect={(obj) => handleFilterChange("itemId", obj?.sale_id)}
            placeholder="Item"
            showAddNew={false}
          />
        </Col>

        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
            handleFilterChange("fromDate", fromDate);
            handleFilterChange("toDate", toDate);
          }}
        />

        <Col
          xs={24} sm={12} md={9} xl={3}
          style={{ paddingTop: "1.4rem" }}>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            style={{height: 35.19}}
            block
          >
            Get Report
          </Button>
        </Col>
      </Row>
      <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  `}</style>
    </Card>
  );
};

export default ItemLedgerFilters;
